<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="dataList"
      @row-click="clickFn"
      @row-dblclick="dblclickFn"
      tooltip-effect="dark"
      height="100%"
      class="table-list"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column v-for="(th,index) in tableTh" :key="index" :prop="th.name" :label="th.label"></el-table-column>
      <el-table-column label="更新时间" prop="user">
        <template slot-scope="scope">
          <span v-ftime="scope.row.update_date"></span>
        </template>
      </el-table-column>
      <el-table-column label="状态" header-align="center">
        <template slot-scope="scope">
          <el-tag :type="oStateType[scope.row.state]" v-if="scope.row.state !== null">{{oState[scope.row.state]}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

const oState = {
  1: '启用',
  0: '停用'
};

const oStateType = {
  1: 'success',
  0: 'danger'
};

export default {
  name: 'list',
  props: {
    dataList: {
      type: Array
    }
  },
  data() {
    return {
      oState,
      oStateType,
      tableTh: [
        {
          name: 'name',
          label: '角色名称'
        }
      ],
      oActiveItem: null,
      bShowEditDialog: false
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      this.dataList.forEach(item => {
        item.checked = false;
      });
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    },
    clickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('detail');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
